import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import { api } from '@/lib/api'
import type { StatsFilters, ConversationStatsResponse } from '@/types/dashboard'

/**
 * Query keys for dashboard stats queries
 */
export const dashboardKeys = {
  all: ['dashboard'] as const,
  stats: (filters?: StatsFilters) => [...dashboardKeys.all, 'stats', filters] as const,
}

interface UseDashboardStatsParams {
  filters?: StatsFilters
  enabled?: boolean
}

/**
 * Hook for fetching dashboard statistics data
 */
export function useDashboardStats({
  filters,
  enabled = true,
}: UseDashboardStatsParams = {}) {
  return useQuery<ConversationStatsResponse>({
    queryKey: dashboardKeys.stats(filters),
    queryFn: async () => {
      const response = await api.post<ConversationStatsResponse>(
        '/api/charts/conversation-stats',
        {
          assistant_ids: filters?.assistant_ids,
          customer_ids: filters?.customer_ids,
          start_date: filters?.start_date
            ? format(filters.start_date, 'yyyy-MM-dd')
            : undefined,
          end_date: filters?.end_date
            ? format(filters.end_date, 'yyyy-MM-dd')
            : undefined,
        }
      )
      return response.data
    },
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
  })
}

export default useDashboardStats
